import { styled } from "@mui/material/styles";
import { Chip, Typography } from "@mui/material";

export const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: "white",
  fontWeight: 600,
  fontSize: 12,
  paddingLeft: 8,
  height: 22,
  "& .MuiChip-icon": {
    color: "white",
    marginLeft: 0,
    width: 14,
  },
  "& .MuiChip-label": {
    paddingLeft: 8,
    paddingRight: 10,
  },
}));

export const Title = styled(Typography)(({ theme, width }) => ({
  fontSize: 12,
  fontWeight: 500,
  marginTop: 4,
  color: theme.palette.neutral.dark,
  minWidth: 112,
  maxWidth: width,
  opacity: width === 0 ? 0 : 1,
  transition: "opacity 0.3s ease-in-out",
  [theme.breakpoints.up("mobile")]: {
    fontSize: 14,
    marginTop: 5,
  },
}));

export const BadgeContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
}));

export const Container = styled("div")(({ theme }) => ({
  cursor: "default",
  [theme.breakpoints.up("mobile")]: {
    marginTop: 3,
  },
}));
